module.exports = __webpack_public_path__ + "2a3325c31908b6edee3c7794685d76fd.pdf";